var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ loader: true, fadeout: _vm.fadeoutLoader }},[_c('img',{staticClass:"logo pulse",attrs:{"src":require("@/assets/logos/ipoint-logo-450x225.png")}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader-title"},[_c('b',[_vm._v("FIND")]),_vm._v(" WHAT YOU'RE LOOKING FOR... ")])
}]

export { render, staticRenderFns }